import { render, staticRenderFns } from "./grossMarginList.vue?vue&type=template&id=2f33d120&scoped=true"
import script from "./grossMarginList.vue?vue&type=script&lang=js"
export * from "./grossMarginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f33d120",
  null
  
)

export default component.exports